import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13ba19d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "disabled", "placeholder", "maxlength"]
const _hoisted_2 = ["type", "value", "disabled", "maxlength", "placeholder"]

import InputField from './InputField.vue';
import { computed, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: [String, Number],
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  hint: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  mask: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'text',
  },
  multiline: {
    type: Boolean,
    default: false,
  },
  maxLength: {
    type: Number,
  },
  status: {
    type: String,
  },
  informationText: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props





const { mask, type: propType } = toRefs(props);

const fieldType = computed((): string =>
  mask.value ? 'password' : propType.value
);

function onUpdate(event: Event) {
  const element = event.target as HTMLInputElement;
  emit('update:modelValue', element.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputField, {
    title: __props.title,
    "validation-error": __props.validationError,
    hint: __props.hint
  }, _createSlots({
    status: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.status), 1)
    ]),
    default: _withCtx(() => [
      (__props.multiline)
        ? (_openBlock(), _createElementBlock("textarea", {
            key: 0,
            value: __props.modelValue,
            disabled: __props.disabled,
            onInput: onUpdate,
            placeholder: __props.placeholder,
            rows: "3",
            maxlength: __props.maxLength,
            class: _normalizeClass([
        'border-b w-full my-2 py-1',
        {
          'border-red-500 text-red-500': __props.validationError,
          'border-input-decoration': !__props.validationError,
        },
      ])
          }, null, 42, _hoisted_1))
        : (_openBlock(), _createElementBlock("input", {
            key: 1,
            type: _unref(fieldType),
            value: __props.modelValue,
            disabled: __props.disabled,
            maxlength: __props.maxLength,
            onInput: onUpdate,
            placeholder: __props.placeholder,
            class: _normalizeClass([
        'border-b w-full my-2 py-1',
        {
          'border-red-500 text-red-500': __props.validationError,
          'border-input-decoration': !__props.validationError,
        },
      ])
          }, null, 42, _hoisted_2))
    ]),
    _: 2
  }, [
    (__props.informationText)
      ? {
          name: "notes",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.informationText), 1)
          ])
        }
      : undefined
  ]), 1032, ["title", "validation-error", "hint"]))
}
}

})